export interface Story {
    pc: string;
    h5: string;
}

export const getLinks = (locale: string) => {
    const links: Record<string, string> = {
        us: 'https://www.facebook.com/EcoFlowGlobal/',
        ca: 'https://www.facebook.com/EcoFlowGlobal/',
        za: 'https://www.facebook.com/ecoflowsouthafrica',
        au: 'https://www.facebook.com/groups/efaustralia',
        eu: 'https://www.facebook.com/EcoFlowGlobal/',
        uk: 'https://www.facebook.com/groups/ecoflowuk',
        de: 'https://www.facebook.com/EcoFlowDeutschland',
        fr: 'https://www.facebook.com/EcoFlowFrance',
        es: 'https://www.facebook.com/EcoFlowGlobal/',
        it: 'https://www.facebook.com/groups/ecoflowit ',
        jp: 'https://x.com/EcoFlowJapan',
        ph: 'https://www.facebook.com/EcoFlowGlobal/',
        kr: 'https://cafe.naver.com/musicstar2/37080028?boardType=L&utm_source=Cafe&utm_medium=COMMUNITY&utm_campaign=camcha_posting4&utm_id=camcha',
    };
    return links[locale] || undefined;
};

export const imgConf: Record<string, Story[]> = {
    us: [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1742353385282/p2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1742815910470/p2_h5.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1742353389140/p1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1742357583199/p1_h5.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1742353393482/p3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1742815913628/p3_h5.jpg',
        },
    ],
    ca: [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1742353385282/p2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1742815910470/p2_h5.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1742353389140/p1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1742357583199/p1_h5.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1742353393482/p3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1742815913628/p3_h5.jpg',
        },
    ],
    jp: [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1742903836349/p4.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1742903839277/p4_h5.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1742903866273/p5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1742903871140/p5_h5.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1742903903246/p6.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1742903909215/p6_h5.jpg',
        },
    ],
    eu: [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1742354436464/p7.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1742357934462/p7_h5.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1742353389140/p1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1742357583199/p1_h5.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1742353393482/p3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1742815913628/p3_h5.jpg',
        },
    ],
    uk: [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1742354436464/p7.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1742357934462/p7_h5.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1742353389140/p1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1742357583199/p1_h5.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1742353393482/p3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1742815913628/p3_h5.jpg',
        },
    ],
    de: [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1742354436464/p7.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1742357934462/p7_h5.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1742353389140/p1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1742357583199/p1_h5.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1742353393482/p3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1742815913628/p3_h5.jpg',
        },
    ],
    fr: [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1742354436464/p7.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1742357934462/p7_h5.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1742353389140/p1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1742357583199/p1_h5.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1742353393482/p3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1742815913628/p3_h5.jpg',
        },
    ],
    es: [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1742354436464/p7.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1742357934462/p7_h5.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1742353389140/p1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1742357583199/p1_h5.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1742353393482/p3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1742815913628/p3_h5.jpg',
        },
    ],
    it: [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1742354436464/p7.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1742357934462/p7_h5.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1742353389140/p1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1742357583199/p1_h5.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1742353393482/p3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1742815913628/p3_h5.jpg',
        },
    ],
    kr: [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1742353393482/p3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1742815913628/p3_h5.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1742356639122/p8.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1742357937444/p8_h5.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1742354436464/p7.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1742357934462/p7_h5.jpg',
        },
    ],
    au: [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1742353385282/p2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1742815910470/p2_h5.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1742353389140/p1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1742357583199/p1_h5.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1742353393482/p3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1742815913628/p3_h5.jpg',
        },
    ],
    za: [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1742356787129/p9.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1742357940049/p9_h5.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1742356820133/p10.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1742357943678/p10_h5.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1742356840550/p11.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1742357946898/p11_h5.jpg',
        },
    ],
};
